































import { IPRCFilter, IPRCFiltersPayload, RateChangesState } from "@/models";
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace, State } from "vuex-class";
import RateChangesModule from "@/store/modules/rate-changes";

const rateChanges = namespace(RateChangesModule.name);

@Component({
  name: "FiltersApplied"
})
export default class FiltersApplied extends Vue {
  // ===== Store ===== //
  @State("rateChanges") private rateChanges!: RateChangesState;
  @rateChanges.Action("applyIPRCFilters") private applyIPRCFilters!: (payload: IPRCFiltersPayload) => void;
  @rateChanges.Action private removeFilter!: (id: number) => void;
  @rateChanges.Action("resetFilters") private resetFilters!: () => void;
  // ===== Props ===== //

  // ===== Data ===== //

  // ===== Methods ===== //
  private handleClearAllFilters(): void {
    this.resetFilters();
  }
  private async handleRemoveFilter(id: number): Promise<void> {
    await this.removeFilter(id);
    if (this.rateChanges.appliedFilters.length) {
      const payload: IPRCFiltersPayload = {
        filters: this.rateChanges.appliedFilters,
        query: this.rateChanges.appliedFilters.map(filter => filter.query).join("&")
      };
      this.applyIPRCFilters(payload);
    }
  }
  @Watch("rateChanges.appliedFilters")
  private allFiltersCleared(filters: IPRCFilter[]): void {
    if (!filters.length) {
      this.resetFilters();
    }
  }
  // ===== Computed ===== //

  // ===== Lifecycle Hooks ===== //
}
